import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { endpoints } from '@shared/endpoints';

@Injectable({
    providedIn: 'root',
})
export class ChallengesService {
    constructor(private http: HttpClient) {}
    fetchCategoriesForChallenges() {
        return this.http.get<any>(
            endpoints.challenges.children.getCategories()
        );
    }
    fetchEventsForChallenges() {
        return this.http.get<any>(endpoints.challenges.children.getEvents());
    }
    fetchChallenges(categoryId: string) {
        return this.http.get<any>(
            endpoints.challenges.children.getChallenges(categoryId)
        );
    }

    createSingleReward(body: any) {
        return this.http.post<any>(
            endpoints.challenges.children.createSingleChallenge(),
            body
        );
    }
    updateSingleReward(rewardId: string, body: any) {
        return this.http.put<any>(
            endpoints.challenges.children.updateSingleChallenge(rewardId),
            body
        );
    }
    createGroupReward(body: any) {
        return this.http.post<any>(
            endpoints.challenges.children.createGroupChallenge(),
            body
        );
    }
    updateGroupReward(groupId: string, body: any) {
        return this.http.put<any>(
            endpoints.challenges.children.updateGroupChallenge(groupId),
            body
        );
    }
    createChallengeInGroupReward(groupId: string, body: any) {
        return this.http.post<any>(
            endpoints.challenges.children.createChallengeInGroup(groupId),
            body
        );
    }
    updateChallengeInGroupReward(
        groupId: string,
        challengeId: string,
        body: any
    ) {
        return this.http.put<any>(
            endpoints.challenges.children.updateChallengeInGroup(
                groupId,
                challengeId
            ),
            body
        );
    }
    updateChallengesDisplayOrder(body: any[]) {
        return this.http.patch<any>(
            endpoints.challenges.children.updateChallengesDisplayOrder(),
            { displayNumbers: body }
        );
    }

    deleteChallenge(challengeId: string) {
        return this.http.delete<any>(
            endpoints.challenges.children.deleteChallenge(challengeId)
        );
    }
    deleteGroupChallenge(groupId: string) {
        return this.http.delete<any>(
            endpoints.challenges.children.deleteGroupChallenge(groupId)
        );
    }

    fetchEvergreens() {
        return this.http.get<any>(
            endpoints.challenges.children.getEvergreens()
        );
    }

    createEvergreens(body: any) {
        return this.http.post<any>(
            endpoints.challenges.children.createEvergreens(),
            body
        );
    }

    updateEvergreens(entityId: string, body: any) {
        return this.http.put<any>(
            endpoints.challenges.children.updateEvergreens(entityId),
            body
        );
    }

    fetchPerks() {
        return this.http.get<any>(endpoints.userProfile.children.getAllPerks());
    }
}
